var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",class:Object.assign({}, {'app': _vm.isMain && _vm.isAppDevice},      
    _vm.wrapClass,
    _vm.wrapAppClass),attrs:{"id":"app"}},[_c('router-view'),_c('div',{attrs:{"id":"back-to-top"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }